var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpressjsLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 49.59C61.672 50.182 60.232 49.616 58.94 47.676L49.752 34.964L48.424 33.204L37.694 47.718C36.468 49.464 35.182 50.224 32.894 49.606L46.634 31.162L33.842 14.502C36.042 14.074 37.562 14.292 38.912 16.262L48.442 29.132L58.042 16.332C59.272 14.586 60.594 13.922 62.802 14.566L57.842 21.142L51.122 29.892C50.322 30.892 50.432 31.576 51.168 32.542L64 49.59ZM0.016 30.854L1.14 25.326C4.2 14.386 16.74 9.84002 25.388 16.6C30.442 20.576 31.698 26.2 31.448 32.5H2.96C2.532 43.84 10.694 50.684 21.1 47.192C24.75 45.966 26.9 43.108 27.976 39.532C28.522 37.74 29.426 37.46 31.11 37.972C30.25 42.444 28.31 46.18 24.21 48.518C18.084 52.018 9.34 50.886 4.74 46.022C2 43.2 0.868 39.624 0.36 35.8C0.28 35.168 0.12 34.566 0 33.96C0.0106667 32.9254 0.016 31.8907 0.016 30.856V30.854ZM3.012 30.094H28.756C28.588 21.894 23.482 16.07 16.504 16.02C8.844 15.96 3.344 21.646 3.012 30.094Z",
    fill: "#1AB558"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressjsLogoIcon);
export default __webpack_public_path__ + "static/media/expressjs_logo_icon.efcc96c918766265829a00297bc61b67.svg";
export { ForwardRef as ReactComponent };